import React, { useState, useEffect } from "react";
import {
  Navigate,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { useDispatch } from "react-redux";
import LoginPage from "../pages/Login/ui/LoginPage";
import NotFound from "../pages/NotFound/ui/NotFound";
import { loginUser } from "../pages/Login/model/authSlice";
import ResponsiveDrawer from "../shared/widgets/Sidebar/ResponsiveDrawer";
import ObjectDetails from "../pages/ObjectDetails/ui/ObjectDetails";
import MyProperties from "../entities/MyProperties/ui/MyProperties";
import Profile from "../entities/Profile/ui/Profile";
import AddObject from "../entities/AddObject/ui/AddObject";
import Ratings from "../entities/Ratings/ui/Ratings";
import AgentsList from "../entities/Agents/ui/AgentsList/AgentsList";
import AddAgent from "../entities/Agents/ui/AddAgent/AddAgent";
import Contacts from "../entities/Contacts/ui/Contacts";
import { Districts } from "../entities/Districts/ui/Districts";
import { Category } from "../entities/Category/ui/Category";
import Shows from "../entities/Shows/ui/Shows";
import General from "../entities/General/ui/General";
import ProtectedRoute from "./protected/ProtectedRoute";
import EditObject from "../entities/editObject/editObject";
import OnScrollTop from "../shared/components/OnScrollTop/OnScrollTop";
import {Residentals} from "../entities/Residentals/ui/Residentals";

const AppRoutes = () => {
  const dispatch = useDispatch();
  const [initialRoute, setInitialRoute] = useState(null);

  useEffect(() => {
    const checkLoginAndNavigate = async () => {
      try {
        const email = localStorage.getItem("email");
        const password = localStorage.getItem("password");
        const token = localStorage.getItem("token");

        if (token) {
          setInitialRoute("/myProperties");
        } else if (email && password) {
          const userData = { email, password };
          dispatch(loginUser(userData))
              .unwrap()
              .then(() => {
                setInitialRoute("/myProperties");
              })
              .catch(() => {
                setInitialRoute("/login");
              });
        } else {
          setInitialRoute("/login");
        }
      } catch (error) {
        console.error("Ошибка при чтении из localStorage", error);
        setInitialRoute("/login");
      }
    };

    checkLoginAndNavigate();
  }, [dispatch]);

  if (initialRoute === null) {
    return null;
  }

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Navigate to={initialRoute} replace />,
    },
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      path: "/",
      element: (
          <ProtectedRoute>
            <OnScrollTop/>
            <ResponsiveDrawer />
          </ProtectedRoute>
      ),
      children: [
        { path: "myProperties", element: <MyProperties /> },
        { path: "profile", element: <Profile /> },
        { path: "addObject", element: <AddObject /> },
        { path: "general", element: <General /> },
        { path: "objectDetails/:property_type/:id", element: <ObjectDetails /> },
        { path: "edit/:property_type/:id", element: <EditObject /> },
        { path: "ratings", element: <Ratings /> },
        { path: "shows", element: <Shows /> },
        { path: "agentsList", element: <AgentsList /> },
        { path: "addAgent", element: <AddAgent /> },
        { path: "contacts", element: <Contacts /> },
        { path: "districts", element: <Districts /> },
        { path: "residentals", element: <Residentals /> },
        { path: "category", element: <Category /> },
      ],
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ]);

  return <RouterProvider router={router} />;
};

export default AppRoutes;
